import { PurchaseInvoiceGenerator } from '@repo/pdf';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

import {
    useAddPurchasePaymentMutation,
    useGetPurchaseDetailsByIdQuery,
} from '@/features/slice/purchases';
import { useGetStoreSettingsQuery } from '@/features/slice/settings';
import { mapPurchaseToInvoice } from '@/utils/mappers/purchase-to-invoice.mapper';

import { toastError } from '../../../utils';
import { TAddPaymentForm } from '../../cart/add-payment-form.schema';

export const usePurchaseDetails = () => {
    const params = useParams();

    const { id } = params;

    const { data, isLoading, isError, error } = useGetPurchaseDetailsByIdQuery(
        id ?? '',
    );

    const [addPurchasePayment, { isLoading: isPaymentLoading }] =
        useAddPurchasePaymentMutation();

    const { data: storeData } = useGetStoreSettingsQuery({});

    const handleAddPurchasePayment = async (paymentData: TAddPaymentForm) => {
        if (!id) return;

        try {
            await addPurchasePayment({
                purchaseId: id,
                amount: paymentData.payments[0].amount!,
            });
            toast.success('Payment added successfully');
        } catch (error) {
            toastError(error, 'Failed to add payment');
        }
    };

    const printInvoice = () => {
        const purchase = mapPurchaseToInvoice(
            data.data,
            storeData?.data as any,
        );

        const invoice = new PurchaseInvoiceGenerator(purchase);

        invoice.print();
    };

    return {
        data,
        isError,
        isLoading,
        error,
        printInvoice,
        addPurchasePayment,
        isPaymentLoading,
        handleAddPurchasePayment,
    };
};
